// -----------------------------------------------------------------------------
// Libraries
// -----------------------------------------------------------------------------
import React, { useCallback } from "react";
import { Modal } from "antd";
import { loadStripe } from "@stripe/stripe-js/pure";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import cx from "classnames";

// -----------------------------------------------------------------------------
// Components and Helpers
// -----------------------------------------------------------------------------
import { Heading2 } from "themes/default/_typography";
import { notification } from "antd";
import { useStripeCreateSetupSessionMutation } from "store/api/api";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

// -----------------------------------------------------------------------------
// Modal Component
// -----------------------------------------------------------------------------
const SetupPaymentMethodModal = ({ open, onClose, customerId, type, afterComplete }) => {
	const [createSession] = useStripeCreateSetupSessionMutation();

	const fetchClientSecret = useCallback(async () => {
		try {
			const { data } = await createSession({ customer_id: customerId, type: type });
			return data.client_secret;
		} catch (err) {
			notification.error({ message: "Failed to create checkout session." });
		}
	}, [customerId]);

	return (
		<Modal
			className={cx("sb-setup-subscription-modal")}
			title={<Heading2>Add Payment Method</Heading2>}
			centered
			open={open}
			onCancel={onClose}
			width={656}
			footer={null}
			maskClosable={false}
			closable
			destroyOnClose
		>
			<div id="setup-checkout">
				<EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret, onComplete: afterComplete }}>
					<EmbeddedCheckout />
				</EmbeddedCheckoutProvider>
			</div>
		</Modal>
	);
};

export default SetupPaymentMethodModal;

